import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { savePendingNote } from "@/lib/welcomeNote";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (data) => {
    localStorage.setItem("hm_token", data.token);
    setUser(data.user);
    savePendingNote();
  };

  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("hm_token");
    Object.keys(localStorage).filter((k) => k.startsWith("hm_draft_")).forEach((k) => localStorage.removeItem(k));
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, refresh }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
